export default {
  // Navigation
  nav_home: '首页',
  nav_dashboard: '控制面板',
  nav_orders: '订单',
  nav_wallet: '钱包',
  nav_analytics: '数据分析',
  nav_referral: '推荐计划',
  nav_account: '账户',
  nav_notifications: '通知',
  nav_logout: '登出',
  nav_login: '登录',
  nav_signup: '注册',
  nav_deposit_requests: '充值申请',
  nav_withdraw_requests: '提现申请',
  nav_support_ticket: '技术支持',
  nav_system_logs: '系统日志',
  nav_announcements: '公告',
  nav_activity_logs: '活动日志',
  nav_settings: '设置',
  nav_section_main: '主要',
  nav_user_active: '当前在线',
  nav_more: '更多',
  nav_logout_confirm: '您确定要退出登录吗？',
  nav_language: '语言',

  // Dashboard
  dashboard_welcome: '欢迎回来',
  dashboard_total_earnings: '累计收益',
  dashboard_pending_orders: '待处理订单',
  dashboard_completed_orders: '已完成订单',
  dashboard_commission_rate: '佣金率',
  dashboard_quick_actions: '快捷操作',
  dashboard_recent_orders: '最近订单',
  dashboard_recent_activity: '最近活动',
  dashboard_wallet_balance: '钱包余额',
  dashboard_deposit: '充值',
  dashboard_withdraw: '提现',
  dashboard_view_all: '查看全部',
  greeting_morning: '早上好',
  greeting_afternoon: '下午好',
  greeting_evening: '晚上好',
  dashboard_greeting_desc: '一站式追踪收益、完成订单并管理您的账户。您的成功之旅在此继续！',

  // Dashboard Stats
  stats_available_balance: '可用余额',
  stats_total_withdrawn: '累计提现',
  stats_total_deposit: '累计充值',
  stats_pending_orders: '待处理订单',
  stats_orders_suffix: ' 个订单',
  stats_task_earnings: '任务收益',
  stats_lifetime_earning: '终生收益',

  // Orders
  orders_title: '我的订单',
  orders_all: '所有订单',
  orders_pending: '待处理',
  orders_completed: '已完成',
  orders_cancelled: '已取消',
  orders_order_id: '订单 ID',
  orders_platform: '平台',
  orders_amount: '金额',
  orders_commission: '佣金',
  orders_status: '状态',
  orders_date: '日期',
  orders_no_orders: '未找到订单',

  // Wallet
  wallet_title: '我的钱包',
  wallet_available_balance: '可用余额',
  wallet_pending_balance: '待处理余额',
  wallet_total_withdrawn: '累计提现',
  wallet_deposit_now: '立即充值',
  wallet_withdraw_now: '立即提现',
  wallet_transaction_history: '交易记录',
  wallet_deposit_history: '充值记录',
  wallet_withdrawal_history: '提现记录',
  wallet_deposit_desc: "使用可用的支付方式向您的钱包充值。",
  wallet_no_deposits: "没有充值记录。",
  wallet_withdraw_history: "提现记录",
  wallet_withdraw_desc: "从您的钱包中提现。",
  wallet_no_withdrawals: "没有提现记录。",
  wallet_no_withdrawals_desc: "您还没有进行任何提现。",

  // Analytics
  analytics_title: '数据分析',
  analytics_earnings_overview: '收益概览',
  analytics_platform_breakdown: '平台分布',
  analytics_performance_metrics: '性能指标',
  analytics_top_products: '热门产品',
  analytics_this_month: '本月',
  analytics_last_month: '上月',
  analytics_total_revenue: '总收入',
  analytics_avg_order_value: '平均订单价值',

  // Referral
  referral_title: '推荐计划',
  referral_your_code: '您的推荐码',
  referral_copy_code: '复制邀请码',
  referral_share_link: '分享链接',
  referral_total_referrals: '总推荐人',
  referral_active_referrals: '活跃推荐',
  referral_referral_earnings: '推荐收益',
  referral_invite_friends: '邀请好友',

  // Account
  account_title: '账户设置',
  account_profile: '个人资料',
  account_security: '安全',
  account_notifications: '通知',
  account_kyc: '身份认证',
  account_phone: '电话号码',
  account_two_factor: '双重身份验证',
  account_save_changes: '保存更改',
  account_cancel: '取消',

  // Auth & Common
  auth_email: '电子邮件',
  auth_password: '密码',
  auth_confirm_password: '确认密码',
  auth_forgot_password: '忘记密码？',
  auth_remember_me: '记住我',
  auth_login_button: '登录',
  auth_signup_button: '注册',
  auth_already_have_account: '已有账户？',
  auth_dont_have_account: "还没有账户？",
  auth_reset_password: '重置密码',
  auth_verify_email: '验证邮箱',
  auth_live_platform: '实时平台',
  auth_security_verification: '安全验证',
  auth_captcha_refresh: '刷新',
  auth_captcha_placeholder: '结果',
  auth_captcha_error: '结果错误，请重试',
  auth_branding_title: '将推广转化为',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: '真实收入',
  auth_branding_desc: '加入数千名推广者的行列，从全球顶级电子商务品牌中赚取每日佣金。',
  auth_sign_in_to_account: '登录您的 {{system_name}} 账户',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: '输入您的密码',
  auth_signing_in: '正在登录...',
  auth_free_to_join: '免费加入',
  auth_signup_branding_title: '开始赚钱',
  auth_signup_branding_highlight: '从第一天起',
  auth_signup_branding_desc: '无需经验。2 分钟内完成注册，开始为顶级电子商务品牌完成任务。',
  auth_how_it_works: '工作原理',
  auth_signup_desc: '加入 {{system_name}}，立即开始赚取佣金——它是免费的！',
  auth_step_1: '创建您的免费账户',
  auth_step_2: '浏览并接受任务',
  auth_step_3: '完成并赚取佣金',
  auth_signup_step_1_title: '创建账户',
  auth_signup_step_1_desc: '开启您的旅程',
  auth_signup_step_2_title: '完成任务',
  auth_signup_step_2_desc: '赚取每日佣金',
  auth_signup_step_3_title: '提取资金',
  auth_signup_step_3_desc: '快速安全的提现',
  auth_benefit_1_title: '安全可信',
  auth_benefit_1_desc: '银行级安全保障您的收益',
  auth_benefit_2_title: '即时提现',
  auth_benefit_2_desc: '24 小时内提取收益',
  auth_benefit_3_title: '全球社区',
  auth_benefit_3_desc: '加入 12,000+ 活跃推广者',
  auth_benefit_4_title: '24/7 支持',
  auth_benefit_4_desc: '随时随地获得帮助',
  auth_strength_weak: '弱',
  auth_strength_fair: '较好',
  auth_strength_good: '好',
  auth_strength_strong: '强',
  auth_password_strength: '密码强度: {{strength}}',
  auth_social_proof: '加入 {{count}}+ 赚钱者',
  auth_passwords_match: '密码匹配',
  auth_creating_account: '正在创建账户...',
  auth_phone_number: '电话号码',
  auth_phone_optional: '(选填)',
  auth_phone_placeholder: '您的电话号码',
  auth_full_name: '全名',
  auth_full_name_placeholder: '张三',
  auth_password_min_chars: '至少 8 个字符',
  auth_confirm_password_placeholder: '重复您的密码',
  auth_agree_to: '我同意',
  auth_terms_of_service: '服务条款',
  auth_privacy_policy: '隐私政策',
  auth_and: '和',
  auth_create_free_account: '创建免费账户',

  common_loading: '加载中...',
  common_save: '保存',
  common_cancel: '取消',
  common_delete: '删除',
  common_edit: '编辑',
  common_view: '查看',
  common_search: '搜索',
  common_filter: '筛选',
  common_export: '导出',
  common_import: '导入',
  common_submit: '提交',
  common_close: '关闭',
  common_confirm: '确认',
  common_success: '成功',
  common_error: '错误',
  common_warning: '警告',
  common_announcement: '公告',

  val_full_name_required: '全名是必填项',
  val_email_required: '电子邮件是必填项',
  val_password_required: '密码是必填项',
  val_password_min: '密码至少 8 个字符',
  val_passwords_dont_match: '密码不匹配',
  val_agree_terms: '您必须同意条款',
  val_conn_error: '连接错误。请重试。',

  // Homepage
  home_hero_title: '从顶级电子商务平台赚取佣金',
  home_hero_subtitle: '加入成千上万的用户，每天从沃尔玛、阿里巴巴和速卖通赚取佣金',
  home_get_started: '立即开始',
  home_learn_more: '了解更多',
  home_how_it_works: '工作原理',
  home_features: '功能特点',
  home_why_choose_us: '为什么选择我们',
  home_features_title: '强大功能',
  home_features_subtitle: '开启在线赚钱所需的一切。为您的成功精心打造。',
  home_commission_tiers: '佣金等级',
  home_testimonials: '用户评价',
  home_faq: '常见问题',
  home_cta_title: '准备好开始赚钱了吗？',
  home_cta_subtitle: '立即加入我们的社区并开始赚取佣金',
  home_trusted_partner: '合作伙伴平台',
  home_secure_platform: '安全平台',
  home_instant_payouts: '即时提现',
  home_active_users: '活跃用户',
  home_paid_out: '已支付',
  home_total_paid_out: '累计已支付',
  home_user_rating: '用户评分',
  home_countries: '国家',
  home_commission_badge: '赚钱潜力',
  home_commission_title: '佣金率',
  home_commission_desc: '余额越高，解锁的佣金率越高。每个阶段分配正好 25 个订单——每天最多完成 4 个阶段，以获得最高收益。',
  home_tier_popular: '最受欢迎',
  home_tier_commission_per_order: '每单佣金',
  home_tier_earn_examples: '收益示例:',
  home_tier_order: '订单',
  home_tier_batch_earn: '25单/阶段收益:',
  home_tier_daily_potential: '每日潜力 (4 组 × 25 单)',
  home_tier_max_daily: '每天最多 100 个订单',
  home_tier_benefit_1: '每组 25 个订单',
  home_tier_benefit_2: '每天最多 4 组',
  home_tier_benefit_3: '佣金即时到账',
  home_tier_above: '以上',
  home_tier_no_tiers: '未找到佣金等级。',

  // Comparison Section
  home_compare_badge: '我们的优势',
  home_compare_title: '为什么我们更好',
  home_compare_subtitle: '将我们的平台与传统的兼职工作进行对比，了解为什么成千上万的人选择我们。',
  home_compare_feature: '特点',
  home_compare_traditional: '传统工作',
  home_compare_our_platform: '我们的平台',
  home_compare_f1: '灵活性',
  home_compare_f1_trad: '固定日程',
  home_compare_f1_our: '随时随地工作',
  home_compare_f2: '支付',
  home_compare_f2_trad: '月结或双周结',
  home_compare_f2_our: '即时 / 当天',
  home_compare_f3: '要求',
  home_compare_f3_trad: '经验/简历/面试',
  home_compare_f3_our: '无 - 只需要一部智能手机',
  home_compare_f4: '增长',
  home_compare_f4_trad: '固定的年度加薪',
  home_compare_f4_our: '无上限的等级增长',

  // Testimonials
  home_testi_badge: '成功案例',
  home_testi_title: '成千上万用户的信任',
  home_testi_subtitle: '听听我们全球推广者社区的声音，他们已经通过我们改变了收入。',
  home_testi_no_stories: '暂无成功案例。',
  home_testi_total_earned: '累计获得',
  home_testi_time_period: '时间跨度',
  home_testi_verified: '认证用户',
  home_testi_avg_rating: '平均评分',
  home_testi_satisfaction_rate: '满意度',
  home_testi_support_available: '全天候支持',

  // FAQ
  home_faq_badge: '支持中心',
  home_faq_title: '常见问题',
  home_faq_subtitle: '开户与赚钱所需知道的一切。',
  home_faq_no_data: '未找到问题。',

  // Trust Bar
  home_trust_badge: '全球信任',
  home_trust_title: '顶级品牌信赖',
  home_trust_desc: '我们与全球最大的电子商务平台合作，提供经过验证的推广服务。',

  // Feature Section
  feature_1_title: '即时提现',
  feature_1_desc: '订单完成后佣金立即到账。随时提现，零延迟。',
  feature_1_detail_1: '实时佣金结算',
  feature_1_detail_2: '多种提现方式',
  feature_1_detail_3: '无最低额度限制',
  feature_2_title: '安全平台',
  feature_2_desc: '银行级加密保护您的数据和收益。深受全球数千名用户的信赖。',
  feature_2_detail_1: '开启 SSL 加密',
  feature_2_detail_2: '双重身份确认',
  feature_2_detail_3: '定期安全审计',
  feature_2_detail_4: '保障数据隐私',
  feature_3_title: '灵活工时',
  feature_3_desc: '随时随地工作。按照自己的节奏完成订单，没有固定时间表。',
  feature_3_detail_1: '无固定工作时间',
  feature_3_detail_2: '远程办公',
  feature_3_detail_3: '自由节奏',
  feature_3_detail_4: '周末可用',
  feature_4_title: '渐进式收益',
  feature_4_desc: '完成更多订单以解锁更高的佣金率。随着每次等级升级，增加您的收入。',
  feature_4_detail_1: '等级佣金制度',
  feature_4_detail_2: '自动升级等级',
  feature_4_detail_3: '表现奖励',
  feature_5_title: '全球平台',
  feature_5_desc: '在全球任何地方与国际品牌合作。包含多币种支持。',
  feature_5_detail_1: '全球可用',
  feature_5_detail_2: '多币种支持',
  feature_5_detail_3: '本地支付方式',
  feature_6_title: '24/7 全天候支持',
  feature_6_desc: '我们专门的支持团队随时准备为您提供帮助。通过实时聊天、电子邮件或电话获得支持。',
  feature_6_detail_1: '可进行实时聊天',
  feature_6_detail_2: '24/7 邮件支持',
  feature_6_detail_3: '电话协助',
  feature_6_detail_4: '全面的常见问题解答',
  feature_7_title: '推荐计划',
  feature_7_desc: '通过邀请朋友赚取额外收入。从您的推荐人的收益中获得终身佣金。',
  feature_7_detail_1: '终身推荐收益',
  feature_7_detail_2: '无限制推荐',
  feature_7_detail_3: '简单的分享工具',
  feature_7_detail_4: '奖金激励',
  feature_8_title: '多币种支持',
  feature_8_desc: '支持主要货币和支付方式。选择最适合您的支付方式。',
  feature_8_detail_1: '支持 USD, EUR, GBP',
  feature_8_detail_2: '提供银行转账',
  feature_8_detail_3: '电子钱包集成',
  feature_8_detail_4: '加密货币选项即将推出',
  feature_9_title: '即时通知',
  feature_9_desc: '实时了解新订单、收益和账户活动的提醒。',
  feature_9_detail_1: '推送通知',
  feature_9_detail_2: '邮件提醒',
  feature_9_detail_3: '短信更新',
  feature_9_detail_4: '应用内消息',

  // Home Page Additional Sections
  home_how_it_works_badge: '简单流程',
  home_how_it_works_title: '工作原理',
  home_how_it_works_subtitle: '通过 4 个简单步骤开始赚钱。无需经验，只需按照流程操作，看着您的收益增长。',
  home_cta_ready_title: '准备好开启您的旅程了吗？',
  home_cta_ready_desc: '加入数千名已经在日常赚钱的用户。您的第一笔佣金就在几分钟之后！',
  home_cta_avg_time: '首次收益平均用时:',
  home_cta_15_mins: '15 分钟',
  home_cta_new_users: '今日新用户:',

  // CTA Section (Premium)
  home_cta_limit_spots: '本月名额有限',
  home_cta_main_title: '开始赚钱',
  home_cta_today: '就在今天！',
  home_cta_main_desc: '加入成千上万每日赚取佣金的用户。无需经验，自由时间，即时到账。您的财务自由从这里开始。',
  home_cta_spots_remaining: '剩余名额',
  home_cta_new_users_today: '今日新入驻',
  home_cta_create_account: '创建免费账户',
  home_cta_sign_in: '登录',
  home_cta_secure: '100% 安全',
  home_cta_payouts: '24-48小时内到账',
  home_cta_rating: '4.9/5 评分',
  home_cta_active_users: '活跃用户',
  home_cta_total_paid: '累计支付',
  home_cta_orders_done: '已完成任务',
  home_cta_satisfaction: '满意度',
  home_cta_guarantee_title: '保障政策',
  home_cta_guarantee_desc: '不满意？7天内可退还您的资金',

  // Footer Branding & Extras
  footer_brand_desc: '全球领先的电子商务推广平台。今天就加入我们的全球推广者网络，开始从顶级品牌中赚取佣金。',
  footer_ssl_secure: 'SSL 安全保护',
  footer_aes_256: 'AES-256 位加密',
  footer_cookie_policy: 'Cookie 政策',
  footer_disclaimer: '免责声明',
  footer_all_rights: '版权所有。',

  // Announcements
  announcement_withdrawal_delay_title: '提现处理延迟公告',
  announcement_withdrawal_delay_summary: '由于提现量激增，处理可能需要长达 72 小时。请提前做好规划。',
  announcement_date_june_14: '2025年6月14日',

  // How It Works Steps
  step_1_title: '注册账户',
  step_1_desc: '不到 2 分钟即可完成创建。',
  step_1_detail_1: '输入基本信息',
  step_1_detail_2: '验证您的邮箱地址',
  step_1_detail_3: '保障账户安全',
  step_1_detail_4: '即时进入控制面板',
  step_2_title: '选择任务',
  step_2_desc: '从可用的推广任务中挑选。',
  step_2_detail_1: '按平台筛选',
  step_2_detail_2: '查看佣金比例',
  step_2_detail_3: '接受多项任务',
  step_2_detail_4: '实时任务更新',
  step_3_title: '完成任务',
  step_3_desc: '按照说明完成推广。',
  step_3_detail_1: '简单易懂的操作说明',
  step_3_detail_2: '快速提交任务',
  step_3_detail_3: '自动审核验证',
  step_3_detail_4: '适配移动端的操作界面',
  step_4_title: '获利与提现',
  step_4_desc: '完成每项任务即获得报酬。',
  step_4_detail_1: '实时收益追踪',
  step_4_detail_2: '极低提现门槛',
  step_4_detail_3: '多种支付渠道',
  step_4_detail_4: '24/7 提现支持',

  // Redesigned Footer
  footer_stay_loop_title: '保持联系',
  footer_stay_loop_desc: '直接在您的收件箱中获取最新的更新、技巧和独家优惠。',
  footer_subscribe: '订阅',
  footer_subscribe_placeholder: '输入您的电子邮件地址',
  footer_trusted_secure: '值得信赖且安全：',
  footer_ssl_secured: 'SSL 安全',
  footer_ssl_secured_desc: '256 位 SSL',
  footer_aes_encryption: 'AES-256 加密',
  footer_aes_encryption_desc: '银行级',
  footer_kyc_compliant: '符合 KYC',
  footer_kyc_compliant_desc: '已验证',
  footer_gdpr_compliant: '符合 GDPR',
  footer_gdpr_compliant_desc: '数据受保护',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: '已认证',
  footer_platform: '平台',
  footer_support: '支持',
  footer_legal: '法律',
  footer_help_center: '帮助中心',
  footer_contact_us: '联系我们',
  footer_payments_label: '支付：',
  home_live_activity_title: '平台实时动态',
  home_recent_activity_title: '最近活动',
  home_total_commissions_paid: '已支付总佣金',
  home_active_users_online: '在线活跃用户',
  home_tasks_completed_today: '今日完成任务',
  account_security_tips_title: '安全建议',
  account_security_tips_desc: '遵循以下简单的最佳实践来提高您的账户保护。',
  tip_password_title: '强密码',
  tip_password_desc: '使用字母、数字和符号的组合，确保您的账户保持安全。',
  tip_two_factor_title: '身份验证',
  tip_two_factor_desc: '保持联系信息更新，以便接收重要的安全通知。',
  tip_logout_title: '定期退出',
  tip_logout_desc: '使用公共或共享计算机时，请务必登出您的账户。',
  tip_sharing_title: '切勿分享访问权限',
  tip_sharing_desc: '我们的支持团队绝不会询问您的密码。切勿与任何人分享您的凭据。',
};